import { render, staticRenderFns } from "./PublicDeliverableAssets.vue?vue&type=template&id=ea0aaa6c&scoped=true"
import script from "./PublicDeliverableAssets.vue?vue&type=script&lang=js"
export * from "./PublicDeliverableAssets.vue?vue&type=script&lang=js"
import style0 from "./PublicDeliverableAssets.vue?vue&type=style&index=0&id=ea0aaa6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0aaa6c",
  null
  
)

export default component.exports